import React, { forwardRef, useCallback, useEffect } from 'react';
import clsx from 'clsx';
import { NavLink } from 'react-router-dom';
import { MenuItem, ListItemIcon, Tooltip } from '@material-ui/core';
import styles from './styles';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

const NavLinkRef = forwardRef((props, ref) => (
  <NavLink innerRef={ref} {...props} />
));

export default forwardRef(({ leftIcon, onClick, sidebarIsOpen }, ref) => {
  const cls = styles();
  const handleMenuTap = useCallback((e) => onClick && onClick(e), [onClick]);
  const user = useSelector((state) => state.reducer.user);

  const { pathname, search } = useLocation();

  const location = useLocation();

  const enable_export = localStorage.getItem('enable_export');

  const renderMenuItem = () => (
    <MenuItem
      className={clsx(sidebarIsOpen ? cls.open : cls.close)}
      activeClassName={cls.active}
      component={NavLinkRef}
      ref={ref}
      to={
        pathname === '/search-detail/empty' ||
        pathname === '/search-detail/export'
          ? location.pathname + location.search
          : '/search'
      }
      onClick={handleMenuTap}>
      <ListItemIcon className={cls.listItemIcon}>{leftIcon}</ListItemIcon>
      <span className="DashboardItemText">Search</span>

      {user.id && (
        <div className="RequestResource" style={{ width: '100%' }}>
          {Number(enable_export) === 1 && (
            <div className={cls.child}>
              <MenuItem
                className={cls.item}
                activeClassName={cls.itemActive}
                component={NavLinkRef}
                ref={ref}
                to={
                  pathname === '/search'
                    ? '/search'
                    : pathname === '/search/empty'
                    ? '/search/empty'
                    : pathname === '/search-detail/empty'
                    ? location.pathname + location.search
                    : '/search-detail/empty'
                }
                onClick={handleMenuTap}>
                Empty
              </MenuItem>
              <MenuItem
                className={cls.item}
                activeClassName={cls.itemActive}
                component={NavLinkRef}
                ref={ref}
                to={
                  pathname === '/search-detail/export'
                    ? location.pathname + location.search
                    : '/search/export'
                }
                onClick={handleMenuTap}>
                Export
              </MenuItem>
            </div>
          )}
        </div>
      )}
    </MenuItem>
  );

  if (sidebarIsOpen) return renderMenuItem();

  return (
    <Tooltip arrow title="features" placement="right">
      {renderMenuItem()}
    </Tooltip>
  );
});
